import { firebaseAuth } from "./firebaseConfig";

export const getCachedToken = () => {
  const { currentUser } = firebaseAuth;

  return currentUser ? currentUser.getIdToken() : null;
};
